import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';

export interface VenueAnalysisVisibleSections {
    market: boolean;
    orders: boolean;
    fills: boolean;
}

export const initialVenueAnalysisVisibleSections = {
    market: true,
    orders: true,
    fills: true,
};

export interface VenueAnalysisConfigurationState
    extends WidgetConfigWithHideableToolbar {
    visibleSections: VenueAnalysisVisibleSections;
    includePreviousDaysFills?: boolean;
    avgPriceDecimals: number;
}

export const initialVenueAnalysisConfigurationState: VenueAnalysisConfigurationState =
    {
        visibleSections: initialVenueAnalysisVisibleSections,
        avgPriceDecimals: 4,
    };

export function toggleVenueAnalysisConfigProperty(
    venueAnalysisConfigurationState: VenueAnalysisConfigurationState,
    property: keyof VenueAnalysisVisibleSections
) {
    return {
        ...venueAnalysisConfigurationState,
        visibleSections: {
            ...venueAnalysisConfigurationState.visibleSections,
            [property]:
                !venueAnalysisConfigurationState.visibleSections[property],
        },
    };
}
